export class DefineStep {

  public static notOptimizedScoreCheckFinish: string[] = [
    'not_optimized_score_check_finish'
  ];
  public static connectionFlowFinish: string[] = [
    'connection_flow_finish'
  ];
}
